import React from 'react';
import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import styles from './GuideStep.module.scss';

/**
 * One entry in a numbered, vertically-railed step-by-step guide (install
 * guides, uninstall guides, setup walkthroughs, etc). The connecting line
 * to the next step is drawn via CSS on `:last-child`, so no `isLast` prop
 * is needed — steps are just rendered in order inside a wrapping list.
 */
export const GuideStep = ({ number, title, children }) => (
  <div className={styles.step}>
    <div className={styles.rail}>
      <div className={styles.circle}>{number}</div>
      <div className={styles.line} />
    </div>
    <div className={styles.body}>
      <Text
        variant={textVariantsEnum.Text_lg}
        fontWeight={fontWeightEnum.Semibold}
        color="gray-900"
      >
        {title}
      </Text>
      <div className={styles.content}>{children}</div>
    </div>
  </div>
);

GuideStep.displayName = 'GuideStep';
